module.exports = __webpack_public_path__ + "static/media/ios-briefcase.67a166ff.svg";